var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDisableicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#999999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2816_7028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2154 7.81833L17.1798 6.78262C16.7066 6.30943 15.9367 6.30945 15.4635 6.78262L15.0582 7.188L17.81 9.94009L18.2154 9.53471C18.6897 9.06041 18.6897 8.29268 18.2154 7.81833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63391 14.8379L7.14818 17.4611C7.12811 17.5695 7.16267 17.6809 7.24063 17.7589C7.31869 17.8369 7.43008 17.8714 7.53836 17.8513L10.1614 17.3656L7.63391 14.8379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5847 7.66211L7.99524 14.2521L10.7471 17.0042L17.3366 10.4142L14.5847 7.66211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2816_7028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.4286,
    height: 11.4286,
    fill: "white",
    transform: "translate(7.14258 6.42773)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDisableicon);
export default __webpack_public_path__ + "static/media/editDisableicon.3efec780ddcfaf2b0bbd1ca779079b2d.svg";
export { ForwardRef as ReactComponent };